import React from 'react'
import { motion } from 'framer-motion'
import { TrendingUp, Plus } from 'lucide-react'
import { usePortfolioStore } from '../store/portfolioStore'
import Button from './ui/Button'

const EmptyState: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center min-h-[60vh] text-center"
    >
      <div className="w-24 h-24 bg-brand-soft rounded-full flex items-center justify-center mb-6">
        <TrendingUp className="w-12 h-12 text-primary-600 dark:text-primary-400" />
      </div>
      
      <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white mb-4">
        Start Your Investment Journey
      </h2>
      
      <p className="text-gray-600 dark:text-gray-400 max-w-md mb-8 leading-relaxed">
        Track your stocks, monitor performance, and manage your portfolio across multiple currencies. 
        Add your first investment to get started.
      </p>
      
      <Button
        onClick={() => usePortfolioStore.setState({ showAddModal: true })}
       
      >
        <Plus className="w-5 h-5" />
        Add Your First Stock
      </Button>
      
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-2xl">
        <div className="text-center p-4">
          <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center mx-auto mb-3">
            <span className="text-blue-600 dark:text-blue-400 text-xl">🇺🇸</span>
          </div>
          <h3 className="font-semibold text-gray-900 dark:text-white mb-1">US Stocks</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">NASDAQ, NYSE stocks</p>
        </div>
        
        <div className="text-center p-4">
          <div className="w-12 h-12 bg-orange-100 dark:bg-orange-900/30 rounded-lg flex items-center justify-center mx-auto mb-3">
            <span className="text-orange-600 dark:text-orange-400 text-xl">🇹🇭</span>
          </div>
          <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Thai Stocks</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">SET listed stocks</p>
        </div>
        
        <div className="text-center p-4">
          <div className="w-12 h-12 bg-green-100 dark:bg-green-900/30 rounded-lg flex items-center justify-center mx-auto mb-3">
            <span className="text-gain text-xl">🏦</span>
          </div>
          <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Thai Funds</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">Mutual funds, ETFs</p>
        </div>
      </div>
    </motion.div>
  )
}

export default EmptyState